/*----------------------------------
- TLD APPLICATIONS PAGING
----------------------------------*/

/**
 * @docs docs/features/tld-intelligence
 * @rule A page number comes from the path only, never from the query: a `page` query
 *       parameter is not a page of this list, it is the base page with a stray parameter.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { TLD_APPLICATIONS_PATH } from '@uniquedomains/components/contracts/tlds/public';
import { TLD_APPLICATIONS_MAX_PAGE } from '@uniquedomains/core/domains/tlds';

/*----------------------------------
- CONSTANTS
----------------------------------*/

const APPLICATIONS_PAGE_PATH_PATTERN = /^\/tld\/applications\/page\/([1-9]\d*)$/;

/*----------------------------------
- PAGING
----------------------------------*/

const toPathname = (requestUrl: string): string =>
    new URL(requestUrl, 'https://unique.domains').pathname.replace(/\/+$/, '');

/**
 * The page number a path names: 1 for the base path, N for `/page/N`, null for anything else
 * or above Product's bound (the page then answers NotFound before any Product call).
 */
export const resolveTldApplicationsPage = (requestUrl: string): number | null => {
    const pathname = toPathname(requestUrl);
    if (pathname === TLD_APPLICATIONS_PATH) return 1;
    const rawPage = APPLICATIONS_PAGE_PATH_PATTERN.exec(pathname)?.[1];
    if (!rawPage) return null;

    const page = Number(rawPage);
    return Number.isSafeInteger(page) && page <= TLD_APPLICATIONS_MAX_PAGE ? page : null;
};

/** `/tld/applications/page/1`: the base page under a second URL, answered with a 301. */
export const isTldApplicationsFirstPageAlias = (requestUrl: string): boolean =>
    APPLICATIONS_PAGE_PATH_PATTERN.exec(toPathname(requestUrl))?.[1] === '1';
